import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import DJ from './DJ';
import MC from './MC';
import { ThemeProvider } from './ThemeContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Check which route we're on (supports base path like /zapisy/dj)
const pathname = window.location.pathname;
const search = window.location.search;
const isDJRoute = pathname.endsWith('/dj') || pathname === '/dj' || search.includes('dj');
const isMCRoute = pathname.endsWith('/mc') || pathname === '/mc' || search.includes('mc');

const getComponent = () => {
  if (isDJRoute) return <DJ />;
  if (isMCRoute) return <MC />;
  return <App />;
};

root.render(
  <React.StrictMode>
    <ThemeProvider>
      {getComponent()}
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
